import { useEffect, useRef, useState } from 'react'
import { Tooltip } from '@design-systems/canvas-ui'

export const TruncatedValueTooltip = ({
  children,
  targetSelector = '.lcm-truncated-value-tooltip__value',
  value,
}) => {
  const triggerRef = useRef(null)
  const [isTruncated, setIsTruncated] = useState(false)
  const valueText = String(value ?? '')

  useEffect(() => {
    const target = triggerRef.current?.querySelector(targetSelector)

    if (!target) return undefined

    const updateTruncation = () => {
      setIsTruncated(target.scrollWidth > target.clientWidth)
    }

    updateTruncation()

    if (typeof ResizeObserver === 'undefined') return undefined

    const resizeObserver = new ResizeObserver(updateTruncation)
    resizeObserver.observe(target)

    return () => resizeObserver.disconnect()
  }, [targetSelector, valueText])

  const trigger = (
    <span className="lcm-truncated-value-tooltip__trigger" ref={triggerRef}>
      {children}
    </span>
  )

  return isTruncated ? (
    <Tooltip
      className="lcm-truncated-value-tooltip"
      content={valueText}
      location="top"
    >
      {trigger}
    </Tooltip>
  ) : (
    <span className="lcm-truncated-value-tooltip">{trigger}</span>
  )
}
